import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Keyboard, A11y } from "swiper";
import { Img } from "../../components/shared/img";
import { Link } from "react-router-dom";
import normalizeString from "../../js/utilities/normalizeString";
import { ASSETS_URL } from "../../components/Store";
import { useLanguage } from "../../hooks/use-language";
import { useTranslationsById } from "../../hooks/use-translations-by-id";

/**
 * Componente swiper de editoriales
 * @returns {JSX.Element} Componente SwiperPublishers
 */
export const SwiperPublishers = ({ editoriales }) => {
    const lang = useLanguage();
    const texts = useTranslationsById({ mainSectionName: "libros", language: lang });

    /**
    * Esta función transforma el nombre de la editorial en un parametro buscable 
    * @param {string} caracter //string: caracter que debe ser reemplazado por nuevoCaracter
    * @param {string} nuevoCaracter //string: nuevo caracter
    * @param {string} texto //string: nombre de la editorial
    * @returns 
    */
    const newUrlEditorial = (caracter, nuevoCaracter, texto) => {
        var buscarCaracter = texto.search(caracter);
        var newUrl;
        if (buscarCaracter === -1) {
            newUrl = normalizeString(texto).replace(caracter, nuevoCaracter);
            return newUrl;
        } else {
            return normalizeString(texto);
        }
    };

    /**
         * Esta función crea un SwiperSlide con un conjunto de editoriales
         * @returns {Array<HTMLElement>} arreglo 
         */
    const publishersSlides = () => {
        const institutionSections = [];

        const sectionLength = Math.ceil(editoriales.length / 12);
        for (let i = 0; i < sectionLength; i++) {
            const items = editoriales.slice(i * 12, (i + 1) * 12);
            institutionSections.push(items);
        }
        return institutionSections.map((section, i) => {
            return (
                <SwiperSlide key={`slide-${i}`}>
                    <div className="row mx-0 mb-4">
                        {section.map((publisher, j) => {
                            return (
                                <Link
                                    to={`/editorial/${newUrlEditorial("---", "-", publisher?.nombreEditorial || '')}`}
                                    className="col-4 col-lg-2 p-1 p-lg-2 focusable-by-children-secondary d-flex justify-content-center aling-items-center "
                                    key={`slide-${j}`}
                                    aria-label={`${texts?.getText({id: "publishers.go_to", defaultText: "Ir a la editorial"})} ${publisher?.nombreEditorial}`}
                                >
                                    <div className="w-100 d-flex justify-content-center aling-items-center surface--bg ">
                                        <div
                                            className="m-2"
                                            style={{
                                                height: 136,
                                                width: 120,
                                                pointerEvents: "none",
                                                backgroundImage: `url(${ASSETS_URL}${publisher?.logo})`,
                                                backgroundSize: 'contain',
                                                backgroundPosition: 'center',
                                                backgroundRepeat: 'no-repeat',
                                                filter: "grayscale(100%)",
                                            }}
                                        >
                                            <p className="sr-only">{texts?.getText({id: "publishers.imgAlt", defaultText: "Logo de la editorial"})} - {publisher?.nombreEditorial}</p>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </SwiperSlide>
            );
        });
    };

    return (
        <>
            <Swiper
                autoplay={{
                    delay: 5000,
                }}
                breakpoints={{
                    526: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    992: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    1400: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                }}
                loop={true}
                pagination={{
                    clickable: true,
                    type: "bullets",
                }}
                preloadImages={true}
                slidesPerView={1}
                keyboard={{ enabled: true }}
                modules={[Autoplay, Keyboard, A11y]}
                a11y={{
                    containerMessage: texts.getText({ id: "publishers.containerMessage", defaultText: "todas las editoriales" }),
                    itemRoleDescriptionMessage: texts.getText({ id: "publishers.itemRoleDescriptionMessage", defaultText: "agrupacion de editoriales" }),
                    paginationBulletMessage: texts.getText({ id: "publishers.paginationBulletMessage", defaultText: "ir al siguiente grupo" })
                }}
                onSlideChange={(swiper) => {
                    const status = document.getElementById("carousel-publishers-status");
                    if (status) {
                        status.textContent = `${texts.getText({ id: "publishers.onSlideChange", defaultText: "Grupo de editoriales número" })}  ${swiper.realIndex + 1}`;
                    }
                }}
            >
                {publishersSlides()}
            </Swiper>
            <div aria-live="polite" className="sr-only" id="carousel-publishers-status"></div>
        </>
    )
}